export default __webpack_public_path__ + "f197d421165ee22f43de54b01c582a22.svg";